import React from 'react';
import { useParams } from 'react-router-dom';
import { useTasksDrawer } from './TasksDrawer';

export const TaskDetail: React.FC = () => {
  const { taskId } = useParams<{ taskId: string }>();

  // Dispatch event to open drawer
  useTasksDrawer({ taskId });

  return null;
};

TaskDetail.displayName = 'TaskDetail';
